import { Button, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Tab, Tabs, Theme, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import MyTable, { TableRow } from "../../../components/MyTable";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { searchApprovalGroupsCompanies, searchNotificationGroupsEmployees } from "../../../store/slices/userRequests";
import { deleteNotificationGroups, deleteOrganizationGroupEmployees, getNotificationGroups } from "../../../api/s10OrganizationApi";
import { AuthResponse, ModifyNotificationGroup, NotificationGroups } from "../../../interfaces/auth.interface";
import EditIcon from '@mui/icons-material/Edit';
import MySnackbar from "../../../components/MySnackbar";
import CreateApprovalGroupModal from "./NotificationGroups";
import EmployeesModal from "./EmployeesModal";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';


const tabOptions = [{
    label: "Grupos",
}, {
    label: "Colaboradores",
},
]


const ApprovalEmployeeCard = (row: any) => {
    return (
        <CardContent style={{padding: "0 1rem 1rem 55px"}}>
            <Typography variant="body2" color="text.primary" marginBottom=".5rem">
                {row.EMail} 
            </Typography>
        </CardContent>
    )
}

const NotificationGroupCard = (
    row: any, 
    theme: Theme,
    setNotificationGroupToEdit: (value: ModifyNotificationGroup | undefined) => void,
    setOpenNotificationGroupsModal: (value: boolean) => void,
) => {
    // const theme = useTheme();
    return (
        <CardContent style={{padding: "0  1rem 1rem 1rem"}}>
            <Typography
                gutterBottom
                variant="h6"
                component="div"
                sx={{
                    minHeight: '2.8em',
                    maxHeight: "3.8em",
                    overflow: 'hidden',
                    color: theme.s10palette.S10Blueblue700,
                    alignContent: "center"
                }}
                fontSize=".8em"
            >
                {row.Id} - {row.Name} 
            </Typography>
            <Grid>  
                <Typography variant="subtitle2" color="text.primary" marginBottom=".5rem" display="inline">
                    Tipo de grupo:{" "}
                </Typography>
                <Typography variant="body2" color="text.primary" marginBottom=".5rem" display="inline">
                    {row.TypeName} 
                </Typography>
            </Grid>
            <Button
                variant="contained"
                color="primary"
                onClick={(e) => {
                    e.stopPropagation();
                    setNotificationGroupToEdit(row as any);
                    setOpenNotificationGroupsModal(true)
                }}
                disableElevation
                style={{
                    minWidth: "2rem",
                    minHeight: "2rem",
                    padding: ".25rem"
                }}
            >
                <EditIcon />
            </Button>
        </CardContent>
    )
}

// label: "N. Aprob",
// rowKeyName: "ApproversNumber",
// label: "Grupo de notificación",
// rowKeyName: "NotificationGroupName",
// label: "Área",
// rowKeyName: "OfficeName",

const NotificationGroupsView = () => {

    const theme = useTheme();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const {companies, companiesIsLoading, employees, employeesLoading} = useSelector((state: RootState) => state.userRequests).approvalGroups;
    
    const [tabOptionSelected, setTabOptionSelected] = useState(0);
    const [timeToResetSelectedItems, setTimeToResetSelectedItems] = useState<string>("");
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [selectorFieldName, setSelectorFieldName] = useState<string>("");
    const [selectedCompany, setSelectedCompany] = useState<string>("");
    const [selectedNotificationGroup, setSelectedNotificationGroup] = useState<NotificationGroups | undefined>();
    const [loading, setLoading] = useState<boolean>(false);


    const [notificationGroups, setNotificationGroups] = useState<NotificationGroups[]>([]);
    const [openNotificationGroupsModal, setOpenNotificationGroupsModal] = useState<boolean>(false);
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [selectedItemsLabel, setSelectedItemsLabel] = useState<string[]>([]);
    const [openEmployeesModal, setOpenEmployeesModal] = useState<boolean>(false);
    const [notificationGroupToEdit, setNotificationGroupToEdit] = useState<ModifyNotificationGroup | undefined>();
    const [snackBarMessage, setSnackBarMessage] = useState<any | undefined>();

    const groupHeader = [{
        label: "Id",
        rowKeyName: "Id",
    }, {
        label: "Grupo",
        rowKeyName: "Name",
    }, {
        label: "Tipo",
        rowKeyName: "TypeName",
    }, {
        label: "",
        rowKeyName: "actions",
        customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
            return (
                <Button
                    variant="contained"
                    color="inherit"
                    onClick={() => {
                        setNotificationGroupToEdit(row as any);
                        setOpenNotificationGroupsModal(true)
                    }}
                    disableElevation
                    style={{
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem"
                    }}
                >
                    <EditIcon />
                </Button>
            )
        },
    }];

    const employeeHeader = [{
        label: "Colaboradores",
        rowKeyName: "Descripcion",
    },{
        label: "Correo electrónico",
        rowKeyName: "EMail",
    },];

    const handleCloseModal = ({success, msg}: {success?: boolean, msg?: string}) => {
        setNotificationGroupToEdit(undefined);
        setOpenNotificationGroupsModal(false);
        setOpenEmployeesModal(false)
        if (success) {
            switch (tabOptionSelected) {
                case 0:
                    getNotificationGroups(selectedCompany)
                        .then(response => {
                            setNotificationGroups(response.data);
                        });
                    break;
                case 1:
                    dispatch(searchNotificationGroupsEmployees(selectedNotificationGroup?.Id as any));
                    break;

            }
            setSnackBarMessage({success, msg})
        } else if (msg) {
            setSnackBarMessage({success, msg})
        }
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabOptionSelected(newValue);
    };

    const handleAddAction = () => {
        switch (tabOptionSelected) {
            case 0:
                setOpenNotificationGroupsModal(true)
                break;
            case 1:
                setOpenEmployeesModal(true)
                break
        }
    }

    const handleDeleteNotificationGroups = async (): Promise<boolean> => {
        const ids = selectedItems.map(r => r.value || r);
        const result =  await deleteNotificationGroups({ids})
            .then(({data}) => {
                if (data?.Type === 0) {
                    setSnackBarMessage({success: true, msg: "Grupos eliminados con éxito."})
                    getNotificationGroups(selectedCompany)
                        .then(response => {
                            setNotificationGroups(response.data);
                        });
                    return true;
                } else {
                    console.log(data);
                    setSnackBarMessage({success: false, msg: "Ocurrio un error eliminando grupos"})
                    return false;
                }
            })
        return result;
    }

    const handleResetSelectedItems = () => {
        setTimeToResetSelectedItems(new Date().toISOString())
        setSelectedItems([])
        setLoading(true)
        setLoading(false)
    }

    const handleDeleteEmployees = () => {
        const ids = selectedItems.map(r => r?.value || r);
        return deleteOrganizationGroupEmployees({ids})
            .then(({data}: {data: AuthResponse}) => {
                if (data?.Type === 0) {
                    handleResetSelectedItems();
                    setSnackBarMessage({success: true, msg: "Colaboradores eliminados con éxito."})
                    dispatch(searchNotificationGroupsEmployees(selectedNotificationGroup?.Id as any));
                    return true;
                } else {
                    console.log(data);
                    setSnackBarMessage({success: false, msg: "Ocurrio un error eliminando colaboradores"})
                    return false;
                }
            })
    }

    const handleDeleteAction = async (): Promise<boolean> => {
        switch (tabOptionSelected) {
            case 0:
                return await handleDeleteNotificationGroups();
            case 1:
                return await handleDeleteEmployees();
            default:
                return false
        }
        
    }

    useEffect(() => {
        if (!companies.length || selectedCompany) {
            return;
        }
        const currentCompany = companies.find(c => c?.RUC as any === companyselected?.RUC)
        setSelectedCompany(currentCompany? currentCompany.RUC : companies[0].RUC);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies])

    useEffect(() => {
        if (!connectionId || !companyselected?.Token || companiesIsLoading) {
            return;
        }
        dispatch(searchApprovalGroupsCompanies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Token, connectionId])


    useEffect(() => {
        if (!selectedCompany || loading || tabOptionSelected !== 0) {
            return;
        }
        handleResetSelectedItems();
        setLoading(true);
        setSelectorFieldName("Id");
        getNotificationGroups(selectedCompany)
            .then(response => {
                setNotificationGroups(response.data);
                if (response.data.length) {
                    setSelectedNotificationGroup(response.data[0])
                }
            })
            .finally(() => {
                setLoading(false)
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabOptionSelected, selectedCompany]);
    
    useEffect(() => {
        if (!selectedCompany || loading || tabOptionSelected !== 1 || !selectedNotificationGroup) {
            return;
        }
        handleResetSelectedItems();
        setSelectorFieldName("Id");
        dispatch(searchNotificationGroupsEmployees(selectedNotificationGroup?.Id as any));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabOptionSelected, selectedNotificationGroup]);

    const handleDeleteItems = async () => {

        const data = tabOptionSelected === 0
                        ? notificationGroups
                        : employees;
        const selectedItemsData = (data as any)
                            .filter((d: any) => selectedItems.includes(d[selectorFieldName]))
                            .map((m: any) => tabOptionSelected === 0
                                                ? `Grupo ${m.Name}.`
                                                : m.Descripcion)
        setSelectedItemsLabel(selectedItemsData);
        setOpenDeleteModal(true);
    }

    return (
        <Grid item width="100%" marginTop="1.5rem" minHeight="60%">
            <Paper 
                elevation={3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    minHeight: "10rem",
                    padding: "2rem 1.5rem"
                }}
            >
                <Grid container spacing={2} marginBottom="1.5rem">
                    {companies.length > 0 && <Grid item>
                        <FormControl style={{minWidth: "15rem"}}>
                            <InputLabel id="select-option-label">Empresa</InputLabel>
                            <Select
                                labelId="select-option-label"
                                id="select-option"
                                label={"Empresa"}
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setSelectedCompany(value);
                                }}
                                value={selectedCompany}
                                style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                            >
                                {companies?.map((item, i) => (
                                    <MenuItem
                                        key={i} 
                                        value={item.RUC}
                                    >
                                        {item.Descripcion}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                    {[1,].includes(tabOptionSelected) && notificationGroups.length > 0 && <Grid item>
                        <FormControl style={{minWidth: "15rem"}}>
                            <InputLabel id="select-option-label">Grupo de notificación</InputLabel>
                            <Select
                                labelId="select-option-label"
                                id="select-option"
                                label={"Grupo de aprobación"}
                                onChange={(event: { target: { value: string } }) => {
                                    const value = event.target.value;
                                    setSelectedNotificationGroup(notificationGroups.find(n => `${n.Id}` === `${value}`));
                                }}
                                value={`${selectedNotificationGroup?.Id}`}
                                style={{height: "2.5rem", border: "none", backgroundColor: "white"}}
                            >
                                {notificationGroups?.map((item, i) => (
                                    <MenuItem
                                        key={i} 
                                        value={item.Id}
                                    >
                                        {item.Name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>}
                </Grid>
                <Grid sx={{ borderBottom: 1, borderColor: '#E8E8E8' }}>
                    <Tabs value={tabOptionSelected} onChange={handleChange} aria-label="basic tabs example">
                        {tabOptions.map((t, i) => (
                            <Tab key={i} label={t.label} style={{
                                color: i === tabOptionSelected 
                                    ? `${theme.s10palette.S10Blueblue600}` 
                                    : `${theme.s10palette.S10Greygrey300}`,
                                fontFamily: 'Roboto',
                                fontSize: '1rem',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                            }} />
                        ))}
                    </Tabs>
                </Grid>
                <MyTable
                    key={`${notificationGroups.length}-${employees.length}`}
                    tableHeadRows={tabOptionSelected === 0
                        ? groupHeader
                        : employeeHeader
                    }
                    tableRows={tabOptionSelected === 0
                        ? notificationGroups
                        : employees
                    }
                    selectionOptions={{
                        selectorFieldName,
                        setSelectedItems,
                        timeToResetSelectedItems: timeToResetSelectedItems
                    }}
                    cardComponent={
                        tabOptionSelected === 0
                        ?   {
                                cardContent: (row) => NotificationGroupCard(
                                    row, 
                                    theme, 
                                    setNotificationGroupToEdit, 
                                    setOpenNotificationGroupsModal
                                ),
                            }
                        :   {
                            imageData: {
                                descriptionRowName: "Descripcion",
                            },
                            cardContent:  ApprovalEmployeeCard,
                        }
                    }
                    loading={loading || employeesLoading}
                    hiddenSearchInput={true}
                    customStartItemOptionBar={() => (
                        <Button 
                            variant="outlined"
                            color="primary"
                            style={{backgroundColor: "white", marginRight: ".5rem"}}
                            startIcon={<AddOutlinedIcon />}
                            onClick={handleAddAction}
                        >
                            Agregar
                        </Button>
                    )}
                    customItemOptionBar={() => (
                        <Button 
                            variant="outlined"
                            color="error"
                            style={{backgroundColor: "#F8E6E6"}}
                            disabled={selectedItems.length === 0}
                            onClick={handleDeleteItems}
                            startIcon={<DeleteOutlinedIcon />}
                        >
                            Eliminar
                        </Button>
                    )}
                    tableOptionsBar={{
                        useDrawer: false,
                    }}
                />
            </Paper>
            <Dialog
                open={openDeleteModal}
                aria-labelledby="responsive-dialog-title"
                style={{width: "100%",}}
            >
                <DialogTitle
                    id="responsive-dialog-title" 
                    style={{padding: "0", margin: "2rem", textAlign: "center"}} 
                    variant="h5"
                >
                    ¿Seguro de eliminar seleccionados?
                </DialogTitle>
                <DialogContent style={{width: "100%", textAlign: "center"}}>
                    <Grid container spacing="1.5rem">
                        <Grid item xs={12}>
                            se procederá a eliminar:
                        </Grid>
                    </Grid>
                    <List dense style={{ listStyleType: 'disc', padding: '0 20px' }}>
                        {selectedItemsLabel.map((item, index) => (
                            <ListItem key={index} style={{ padding: '5px 0' }}>
                                <ListItemIcon style={{minWidth: 0}}>
                                    <ArrowRightIcon />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                style={{width: "8rem"}}
                                startIcon={<CloseIcon style={{height: "1rem"}} />}
                                onClick={() => setOpenDeleteModal(false)}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <Button 
                                variant="contained" 
                                color="error"
                                style={{width: "8rem"}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                onClick={async () => {
                                    const reset = await handleDeleteAction();
                                    if (reset) {
                                        handleResetSelectedItems();
                                    }
                                    setOpenDeleteModal(false);
                                }}
                            >
                                Eliminar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            {openNotificationGroupsModal && 
                <CreateApprovalGroupModal
                    companyId={selectedCompany} 
                    handleCloseModal={handleCloseModal}
                    notificationGroupToEdit={notificationGroupToEdit}
                />
            }
            {openEmployeesModal && selectedNotificationGroup && <EmployeesModal 
                ruc={selectedCompany} 
                notificationGroupId={selectedNotificationGroup?.Id} 
                handleCloseModal={handleCloseModal}
            />}
            {snackBarMessage && <MySnackbar 
                msg={snackBarMessage.msg} 
                severity={snackBarMessage.success ? 'success' : 'error'}
                onClose={() => setSnackBarMessage(undefined)}
                open={true}
            />}
        </Grid>
    );
}


export default NotificationGroupsView;